import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Renderer2, Inject  } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { LocalStorageKeys } from '../../models/user';
import { AuthService } from '../../../services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { SharedService } from '../../../services/shared.service';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SAMLSettingComponent } from '../../../favorites/saml-setting/saml-setting.component';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {
  items: MenuItem[] | undefined;
  userData: any;
  sidebarCollapsed:boolean = false;
  isCompanyAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  isEmployee: boolean = false;
  ref: DynamicDialogRef | undefined;
  constructor(
    private renderer: Renderer2,
    private authService: AuthService,
    public dialogService: DialogService,
    private sharedService: SharedService,
    private messageService: MessageService,
    private router: Router,
    @Inject(DOCUMENT) private document: Document

  ){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.removeSidebarClose();
      }
    });
  }
  ngOnInit() {
    this.isSuperAdmin = this.authService.isSuperAdmin();
    this.isCompanyAdmin = this.authService.isCompanyAdmin();
    this.isEmployee = this.authService.isEmployee();


    this.items = [
      ...(this.isCompanyAdmin ? [
        { 
          label: 'SAML Settings', 
          icon: 'pi pi-cog',
          command: () => {
            this.ref = this.dialogService.open(SAMLSettingComponent, {
                header: 'SAML Settings',
                width: '50vw',
                contentStyle: { overflow: 'auto' },
                breakpoints: {
                    '960px': '75vw',
                    '640px': '90vw'
                }
            });
        
            this.ref.onClose.subscribe((data: any) => {
            });
          }
        }
      ] : []),
      { 
        label: 'Change Password', 
        icon: 'pi pi-user-edit',
        command: () => {
          this.ref = this.dialogService.open(ChangePasswordComponent, {
              header: 'Change Password',
              width: '50vw',
              contentStyle: { overflow: 'auto' },
              breakpoints: {
                  '960px': '75vw',
                  '640px': '90vw'
              }
          });
      
          this.ref.onClose.subscribe((data: any) => {
          })
        }
      },
      { 
        label: 'Logout', 
        icon: 'pi pi-sign-out',
        command: () => {
          this.authService.logout().subscribe({
            next: ( data ) =>{
              this.messageService.add({ severity: 'success', summary: 'Success', detail: `${data.detail}` });
              this.authService.clearLocalStorage();
              this.sharedService.updateLnkdConnected('false');
              this.sharedService.updateFbConnected('false');
            },
            error: ({error}: any) =>{
              this.messageService.add({ severity: 'error', summary: 'Error', detail: `${error.detail}` });
              this.router.navigate(['/auth/login']);
            }
          });
        }
      }
    ];
    this.getUserDetails();
    

    // Subscribe to the isConnected$ observable to get updates
    this.sharedService.isConnected$.subscribe((isConnected) => {
      this.userData.isConnected = isConnected;
    });


    // Subscribe to the isFbConnected$ observable to get updates
    this.sharedService.isFbConnected$.subscribe((isFbConnected) => {
      this.userData.isFbConnected = isFbConnected;
    });

    // Subscribe to the isFbBusinessConnected$ observable to get updates
    this.sharedService.isFbBusinessConnected$.subscribe((isFbBusinessConnected) => {
      this.userData.isFbBusinessConnected = isFbBusinessConnected;
    });

    // Subscribe to the isInstaConnected$ observable to get updates
    this.sharedService.isInstaConnected$.subscribe((isInstaConnected) => {
      this.userData.isInstaConnected = isInstaConnected;
    });

    // Subscribe to the isTwitterConnected$ observable to get updates
    this.sharedService.isTwitterConnected$.subscribe((isTwitterConnected) => {
      this.userData.isTwitterConnected = isTwitterConnected;
    });




    // Subscribe to the isConnectedUserName$ observable to get updates
    this.sharedService.isConnectedUserName$.subscribe((isConnectedUserName) => {
      this.userData.isConnectedUserName = isConnectedUserName;
    });


    // Subscribe to the isConnectedFacebookUserName$ observable to get updates
    this.sharedService.isConnectedFacebookUserName$.subscribe((isConnectedFacebookUserName) => {
      this.userData.isConnectedFacebookUserName = isConnectedFacebookUserName;
    });

    // Subscribe to the isConnectedFacebookBusinessUserName$ observable to get updates
    this.sharedService.isConnectedFacebookBusinessUserName$.subscribe((isConnectedFacebookBusinessUserName) => {
      this.userData.isConnectedFacebookBusinessUserName = isConnectedFacebookBusinessUserName;
    });

    // Subscribe to the isConnectedInstaUserName$ observable to get updates
    this.sharedService.isConnectedInstaUserName$.subscribe((isConnectedInstaUserName) => {
      this.userData.isConnectedInstaUserName = isConnectedInstaUserName;
    });

    // Subscribe to the isConnectedTwitterUserName$ observable to get updates
    this.sharedService.isConnectedTwitterUserName$.subscribe((isConnectedTwitterUserName) => {
      this.userData.isConnectedTwitterUserName = isConnectedTwitterUserName;
    });


    
  }

  getDashboardLink(): string[] {
    if (this.isSuperAdmin) {
      return ['/company-management'];
    } 
    else if (this.isEmployee) {
      return ['/synced-post'];
    } 
    else {
      return ['/dashboard'];
    }
  }
  
  getUserDetails(){
    this.userData ={
      firstName: window.localStorage.getItem(LocalStorageKeys.firstName),
      lastName: window.localStorage.getItem(LocalStorageKeys.lastName),
      email: window.localStorage.getItem(LocalStorageKeys.Email),
      role: window.localStorage.getItem(LocalStorageKeys.Role),
      isConnected: window.localStorage.getItem(LocalStorageKeys.Is_connected),
      isFbConnected: window.localStorage.getItem(LocalStorageKeys.Is_fb_connected),
      isFbBusinessConnected: window.localStorage.getItem(LocalStorageKeys.Is_fb_business_connected),
      isInstaConnected: window.localStorage.getItem(LocalStorageKeys.Is_insta_connected),
      isTwitterConnected: window.localStorage.getItem(LocalStorageKeys.Is_twitter_connected),
      isConnectedUserName: window.localStorage.getItem(LocalStorageKeys.LinkedInUserName),
      isConnectedFacebookUserName: window.localStorage.getItem(LocalStorageKeys.FacebookInUserName),
      isConnectedFacebookBusinessUserName: window.localStorage.getItem(LocalStorageKeys.FacebookBusinessUserName),
      isConnectedInstaUserName: window.localStorage.getItem(LocalStorageKeys.InstaUserName),
      isConnectedTwitterUserName: window.localStorage.getItem(LocalStorageKeys.TwitterUserName),
    }
  }
  
  toggleSideBar() {
    if (this.document.body.classList.contains('sidebarClose')) {
      this.renderer.removeClass(this.document.body, 'sidebarClose');
      this.sidebarCollapsed = false;
    } else {
      this.renderer.addClass(this.document.body, 'sidebarClose');
      this.sidebarCollapsed = true;
    }
  }

  removeSidebarClose() {
    if (this.document.body.classList.contains('sidebarClose')) {
      this.renderer.removeClass(this.document.body, 'sidebarClose');
      this.sidebarCollapsed = false;
    }
  }
}
